var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.vehicleImageUrl && !_vm.errorFound
        ? _c("b-img", {
            staticClass: "configured-img",
            attrs: {
              src: _vm.vehicleImageUrl,
              alt: _vm.vehicleName,
              fluid: ""
            },
            on: { error: _vm.onError }
          })
        : _c("body-style-icon", { attrs: { id: _vm.bodyStyle } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }